var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"App"}},[(_vm.currentUser)?[_c('Navbar')]:_vm._e(),_c('div',{staticClass:"container-fluid"},[_c('router-view'),(_vm.currentUser)?[_c('Foot')]:_vm._e()],2)],2)}
var staticRenderFns = []

export { render, staticRenderFns }